// Lightweight cross-component signal so the TopBar credit coin can update the
// moment a student's balance changes (library booking / cancel) instead of
// waiting for its periodic poll. Decoupled on purpose — the booking UIs
// (reservation page, Randevu Oluştur modal) live outside the TopBar tree, so a
// window CustomEvent is the cheapest way to notify without a shared context.

export const CREDITS_EVENT = 'dijipo:credits';

/** Broadcast the latest known credit balance. */
export function emitCreditsChanged(balance: number): void {
  if (typeof balance !== 'number' || Number.isNaN(balance)) return;
  window.dispatchEvent(new CustomEvent<number>(CREDITS_EVENT, { detail: balance }));
}

/** Subscribe to balance changes. Returns an unsubscribe fn. */
export function onCreditsChanged(cb: (balance: number) => void): () => void {
  const handler = (e: Event) => {
    const detail = (e as CustomEvent<number>).detail;
    if (typeof detail === 'number') cb(detail);
  };
  window.addEventListener(CREDITS_EVENT, handler);
  return () => window.removeEventListener(CREDITS_EVENT, handler);
}
